import { Theme } from "@mui/material";
import { useAppSelector } from "@store/store-helper";
import { useMemo } from "react";
import { getTheme } from "@styles/themes";
import { devFeaturesStateSelector } from "@store/dev-features/dev-features-selector";

/**
 * Hook that returns the appropriate theme based on dark mode setting.
 */
export function useDynamicTheme(): Theme {
  const {isDarkModeEnabled} = useAppSelector(devFeaturesStateSelector);

  return useMemo(() => {
    return getTheme(isDarkModeEnabled ? "dark" : "light");
  }, [isDarkModeEnabled]);
}
